import React, { useState, useEffect } from "react";
import { Link, Routes, Route, useMatch, Redirect } from "react-router-dom";

import { ContactBar } from "./contact-bar";
import { FeaturedHelpTopics } from "./featured-help";
import { Search } from "./search";
import { ResourceCentre } from "./resource-centre";
import { ContactDetails } from "./contact-details";
import { ContactFind } from "./contact-find";
import { TrackEvent } from "./utils";
import { Helmet, HelmetProvider } from "react-helmet-async";


export function ContactUs() {

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  // load data
  useEffect(() => {

    fetch(document.querySelector('#root').getAttribute('data-api'))
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          setError({ message: 'Data not found or unexpected format' })
          return false;
        }
      })
      .then((result) => {
        setData(result);
        setIsLoaded(true);
      })
      .catch((err) => {
        setError({ message: err.toString() })
      });

  }, []);

  const [wdeData, setWdeData] = useState({});

  // load WDE
  useEffect(() => {

    if (!data.loadWDE) return;

    // init WDE (webchat scripts) 
    AG.ui.wde.initWDE({
      //widgetServiceBaseUrl: 'https://devgengwebe02.gray.net:9000/anana/v1',
      //widgetServiceBaseUrl: 'https://public-site.uat.gray.net', 
      //widgetServiceBaseUrl: 'https://www.allangray.co.za', 
      widgetServiceBaseUrl: data.wdeSettings.widgetServiceBaseUrl,
      pluginsPath: data.wdeSettings.plugins,
      showSidebar: data.wdeSettings.showSidebar,
      afterWebServiceLoad: function (status) {
        setWdeData({
          "webchatAvailable": status.webchatAvailable,
          "callbackAvailable": status.callbackAvailable
        });
      },
      afterWebchatOpened: function () {

      },
      afterWebchatClosed: function () {

      },
      afterCallbackOpened: function () {

      },
      afterCallbackClosed: function () {

      },
      afterCallbackComplete: function () {

      }
    });

  }, [data]);

  // loading whiteout
  useEffect(() => {
    if (!isLoaded) {
      document.querySelector('main.contact-us').classList.add('is-loading');
    } else {
      document.querySelector('main.contact-us').classList.remove('is-loading');
    }
  }, [isLoaded]);


  if (error) {
    return (
      <div className="notification notification--info notification--left">
        <div className="notification__content">
          <h5 className="font-normal">Error</h5>
          <p>{error?.message}</p>
        </div>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className="page-loading-spinner">
        <i className="agi agi-f-arc"></i>
      </div>
    );
  } else {

    const $rootEl = document.querySelector('#root');

    return (
      <HelmetProvider>

        <div className="well well--contact outer-shadow">

          <ContactBar data={data.bar} />

          {data.searchEnabled && <Search data={data} />}

          {!data.searchEnabled &&
            <div className="contact-search">
              <h1>{data.searchDisabledTitle}</h1>
            </div>
          }

          <Routes>

            <Route path="/" element={  
              <>
                <Helmet>
                  <title>{data.pageTitlePrefix + data.pageTitle}</title>
                  <meta name="description" content={data.pageDescription} />
                  <link rel="canonical" href={window.location.origin + $rootEl.getAttribute('data-basename')} />
                  <meta property="og:url" content={window.location.origin + $rootEl.getAttribute('data-basename')} />
                  <meta property="og:title" content={data.pageTitlePrefix + data.pageTitle} />
                </Helmet>

                <FeaturedHelpTopics data={data} title={data.featuredTitle} limit={data.numFeatured} />

                {!data.browseNow?.disabled &&
                  <div className="contact-browse contact-browse--box">
                    <div className="contact-browse__copy">
                      <h3>{data.browseNow.title}</h3>
                      <p>
                        {data.browseNow.text}
                      </p>
                    </div>
                    <div className="contact-browse__button">
                      <Link to={`/resource-centre`}
                        onClick={() => TrackEvent('button', { 'context': data.browseNow.buttonText })}
                        className="button button--block button--primary">{data.browseNow.buttonText} <i className="agi agi-f-chevron-right"></i></Link>
                    </div>
                  </div>
                }

                {!data.contactDetails?.disabled &&
                  <ContactDetails data={data.contactDetails} wdeData={wdeData} />
                }
                {!data.contactFind?.disabled &&
                  <ContactFind data={data.contactFind} />
                }
              </>
            } />
         

            <Route path="/resource-centre/*" element={<ResourceCentre data={data} />} />

            <Route path="*" element={<NoMatch data={data.notFound} />} />
       

          </Routes>

        </div>

      </HelmetProvider>
    );
  }
}

function NoMatch(props) {
  return (
    <div className="notification notification--info notification--left">
      <div className="notification__content">
        <h5 className="font-normal">{props.data.title}</h5>
        <div
          dangerouslySetInnerHTML={{
            __html: props.data.content
          }}
        ></div>
      </div>
    </div>
  );
}
